/*global sessionStorage*/
import '../app.es6';
import angular from 'angular';
import moment from '../../node_modules/moment/moment.js';

const COMPONENT_NAME = 'sssDatePicker';
class DatePicker {

  /* @ngInject */
  constructor ($scope, $element, $attrs, $filter, SharedState, $location) {
    this.$scope = $scope;
    this.$elm = $element;
    this.$attrs = $attrs;
    this.dateFormatter = $filter('date');
    this.sharedState = SharedState;
    this.playReportController = $scope.$parent.report;
    $scope.renderOnBeforeRender = renderOnBeforeRender;
    this.modes = [
      {value: 'day', label: '日'},
      {value: 'week', label: '週'},
      {value: 'month', label: '月'}
    ];
    this.modes.forEach((m) => {
      this.modes[m.value] = m;
    });
    moment.locale('ja');

    // directive自身にclassを追加する
    $element.addClass('btn-group');

    let msec = parseInt(sessionStorage.getItem('date'), 10) || null;
    let defDate = msec ? new Date(msec) : new Date();

    if ($location.path().match('/report') && $location.path().match('/report').length > 0) {
      let range = $location.path().split('/report/');
      let modeRange = sessionStorage.getItem('dateMode') || 'day';
      switch (range[1]) {
        case 'day': modeRange = 'day'; break;
        case 'week': modeRange = 'week'; break;
        case 'month': modeRange = 'month'; break;
        case 'year': modeRange = 'month'; break;
      }
      this.sharedState.initialize(this.$scope, 'dateMode', {
        defaultValue: modeRange
      });
      this.playReportController.getLatestGroupStartDate().then((date) => {
        this.sharedState.initialize(this.$scope, 'date', {
          defaultValue: new Date(moment(date).valueOf())
        });
      });

      if (modeRange === 'month') {
        this.$scope.config = {
          configureOnConfig: {
            startView: 'month',
            minView: 'month',
            configureOn: 'config-changed'
          }
        };
      } else {
        this.$scope.config = {
          configureOnConfig: {
            startView: 'day',
            minView: 'day',
            configureOn: 'config-changed'
          }
        };
      }
      sessionStorage.setItem('dateMode', modeRange);
    } else {
      this.sharedState.initialize(this.$scope, 'dateMode', {
        defaultValue: sessionStorage.getItem('dateMode') || 'day'
      });
      this.sharedState.initialize(this.$scope, 'date', {
        defaultValue: defDate
      });

      if (sessionStorage.getItem('dateMode') && sessionStorage.getItem('dateMode') === 'month') {
        this.$scope.config = {
          configureOnConfig: {
            startView: 'month',
            minView: 'month',
            configureOn: 'config-changed'
          }
        };
      } else {
        this.$scope.config = {
          configureOnConfig: {
            startView: 'day',
            minView: 'day',
            configureOn: 'config-changed'
          }
        };
      }
    }

    $scope.$on('mobile-angular-ui.state.changed.dateMode', (e, newVal, oldVal) => {
      sessionStorage.setItem('dateMode', newVal);
      if (newVal === 'month') {
        this.$scope.config.configureOnConfig.startView = 'month';
        this.$scope.config.configureOnConfig.minView = 'month';
        this.$scope.$broadcast('config-changed');
      } else {
        this.$scope.config.configureOnConfig.startView = 'day';
        this.$scope.config.configureOnConfig.minView = 'day';
        this.$scope.$broadcast('config-changed');
      }
    });

    $scope.$on('mobile-angular-ui.state.changed.date', (e, newVal, oldVal) => {
      if (newVal) {
        sessionStorage.setItem('date', newVal.getTime());
      }
    });

    DatePicker.$inject = ['$scope', '$element', '$attrs', '$filter', 'SharedState', '$location'];
  }

  get date () {
    return this.sharedState.get('date');
  }

  set date (val) {
    if (val) this.sharedState.set('date', val);
  }

  next () {
    this.move(+1);
  }

  prev () {
    this.move(-1);
  }

  move (val) {
    let key = this.sharedState.get('dateMode');
    this.date = moment(this.date).add(val, key + 's').toDate();
  }

  dateString () {
    switch (this.sharedState.get('dateMode')) {
      case 'day': return this.dateFormatter(this.date, 'yyyy/MM/dd');
      case 'month': return this.dateFormatter(this.date, 'yyyy/MM');
      case 'week': {
        let start = moment(this.date).day(0).toDate();
        let end = moment(this.date).day(6).toDate();
        return `${this.dateFormatter(start, 'yyyy/MM/dd')} - ${this.dateFormatter(end, 'MM/dd')}`;
      }
    }
    return this.date;
  }

  modeString () {
    let mode = this.sharedState.get('dateMode');
    return this.modes[mode].label;
  }

  init () {
  // do something
  }
}

function renderOnBeforeRender ($dates) {
  if (sessionStorage.getItem('dateMode') && sessionStorage.getItem('dateMode') === 'week') {
    let msec = parseInt(sessionStorage.getItem('date'), 10) || null;
    let defDate = msec ? new Date(msec) : new Date();
    angular.forEach($dates, function (dateObject) {
      let w = [];
      for (let x = 0; x <= 6; x++) {
        let d = moment(defDate).day(x).toDate();
        w[x] = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
        if (w[x] === dateObject.utcDateValue) {
          dateObject.active = true;
        }
      }
    });
  }
}

angular.module('myApp').component(COMPONENT_NAME,
  {
    bindings: {},
    controller: DatePicker,
    // TODO : webpack対応でhtmlをimportするよう修正する
    templateUrl: 'views/date-picker.html'
  }
);



// WEBPACK FOOTER //
// ./app/components/date-picker.es6